import { render } from "./VirtualRedTagEntry.vue?vue&type=template&id=bcb65448&scoped=true&ts=true"
import script from "./VirtualRedTagEntry.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagEntry.vue?vue&type=script&lang=ts"

import "./VirtualRedTagEntry.vue?vue&type=style&index=0&id=bcb65448&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb65448"]])

export default __exports__